'use client';

import synthConfig from 'mode-shared/configs/synthConfig';
import { formatDateToHumanReadable } from 'mode-shared/utils/format';

export const MaintenanceBanner = () => {
  if (!synthConfig.maintenanceEndDateUtc) return null;

  const endDateUtc = formatDateToHumanReadable(
    new Date(synthConfig.maintenanceEndDateUtc),
    "HH:mm 'UTC' 'on' EEEE, MMMM do"
  );

  return (
    <div
      role="banner"
      className="w-full rounded-lg border border-warning bg-warning/10 px-4 py-3 text-center text-sm font-medium text-warning"
    >
      We have scheduled maintenance for all services, with an expected downtime of 60 minutes starting at {endDateUtc}.
    </div>
  );
};
